// src/components/Banner.js

import React from 'react';
import { useEffect, useState, useRef } from 'react';

// Componentes de Material-UI
import { useTheme } from '@emotion/react';

// Componentes personalizados de Material Kit 2 PRO React
import MKTypography from 'DS/components/MKTypography';

// Funciones auxiliares

// Imágenes (si son necesarias en el futuro)
import { Box, Grid } from '@mui/material';
import HoverCard from '../components/HoverCard';
import bannerA from 'assets/images/banners/bannerAI.jpg';
import bannerG from 'assets/images/banners/bannerDevelopment.jpg';
import bannerI from 'assets/images/banners/bannerConsulting.jpg';

// Hook personalizado para manejar la coincidencia de consultas de medios
// Hook personalizado para detectar si un elemento está en vista
function useInView(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin: '0px',
        threshold: 0.1,
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  return isIntersecting;
}

function Program() {
  const theme = useTheme();
  const detailRefs = useRef([]);

  // Opcional: Detectar el paso en vista para resaltar en la lista
  // Referencias a cada tarjeta
  const cardRefs = [useRef(), useRef(), useRef()];
  // Estados para saber si cada tarjeta está en vista
  const inViewStates = cardRefs.map((ref) => useInView(ref));
  return (
    <Box
      sx={{
        m: { xs: 2, sm: 3, md: 5 },
        mb: { xs: 10, sm: 15, md: 20 },
      }}
    >
      {/* Título */}
      <MKTypography
        variant="h4"
        align="start"
        color="text"
        sx={{
          fontWeight: 400,
          letterSpacing: 1,
          marginBottom: 4,
        }}
      >
        <b>What</b> we offer
      </MKTypography>

      {/* Contenedor de las Tarjetas */}
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="center"
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        {/* Tarjeta 1 */}
        <Grid
          item
          ref={cardRefs[0]}
          sx={{
            transform: inViewStates[0] ? 'translateX(0)' : 'translateX(100px)',
            opacity: inViewStates[0] ? 1 : 0,
            transition: 'transform 0.5s ease-out, opacity 0.5s ease-out',
          }}
        >
          <HoverCard
            title="AI"
            description="Benefit from the efficiencies achieved through the implementation of AI."
            cta="EXPLORE"
            image={bannerA}
          />
        </Grid>

        {/* Tarjeta 2 */}
        <Grid
          item
          ref={cardRefs[1]}
          sx={{
            transform: inViewStates[1] ? 'translateX(0)' : 'translateX(100px)',
            opacity: inViewStates[1] ? 1 : 0,
            transition: 'transform 1s ease-out 0.3s, opacity 1s ease-out 0.3s',
          }}
        >
          <HoverCard
            title="Development"
            description="Work with the top software engineers on scalable and innovative solutions."
            cta="EXPLORE"
            image={bannerG}
          />
        </Grid>

        {/* Tarjeta 3 */}
        <Grid
          item
          ref={cardRefs[2]}
          sx={{
            transform: inViewStates[2] ? 'translateX(0)' : 'translateX(100px)',
            opacity: inViewStates[2] ? 1 : 0,
            transition: 'transform 1s ease-out 0.6s, opacity 1s ease-out 0.6s',
          }}
        >
          <HoverCard
            title="Consulting"
            description="Take advantage from our experts, industry connections, and essential resources for rapid growth."
            cta="EXPLORE"
            image={bannerI}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Program;
